const ACTIVE_PROJECT_KEY = 'mel_active_project';

const isBrowser = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const safeGetItem = (key) => {
  if (!isBrowser()) return null;

  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    console.warn('Unable to access localStorage:', error);
    return null;
  }
};

const safeSetItem = (key, value) => {
  if (!isBrowser()) return;

  try {
    if (value === undefined || value === null) {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, value);
    }
  } catch (error) {
    console.warn('Unable to write to localStorage:', error);
  }
};

export const getActiveProject = () => {
  const raw = safeGetItem(ACTIVE_PROJECT_KEY);

  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch (error) {
    console.warn('Unable to parse stored project:', error);
    return null;
  }
};

export const setActiveProject = (project) => {
  if (!project) {
    safeSetItem(ACTIVE_PROJECT_KEY, null);
    return;
  }

  const payload = {
    id: project.id || project._id || `custom-${Date.now()}`,
    name: project.name || project.title || 'Unnamed Project',
  };

  safeSetItem(ACTIVE_PROJECT_KEY, JSON.stringify(payload));
};

export const clearActiveProject = () => {
  safeSetItem(ACTIVE_PROJECT_KEY, null);
};

export { ACTIVE_PROJECT_KEY };



